module.exports = {
    runSuite: 'Run suite',
    stopSuite: 'Stop suite',
    runBenchmark: 'Run benchmark',
    stopBenchmark: 'Stop benchmark',
    runAll: 'Run all tests',
    stopAll: 'Stop all tests'
};
